import fp from 'lodash/fp';
import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import styles from './HelpInfo.module.scss';

function GetInfo(simmVersion){
   return [
        {
            title: 'Release Version',
            value: fp.get('APP_ENV_CONFIG.REACT_APP_RELEASE_NAME')(window)
        },
        {
            title: 'SIMM Version',
            value: simmVersion
        },
        {
            title: 'Environment',
            value: fp.get('APP_ENV_CONFIG.REACT_APP_ENVIRONMENT')(window)
        }
    ]

}

const HelpInfo = (props)=> {
    return(
    <div>
        {
            GetInfo(props.simmVersion).map(option => (
            <div key={ option.title } className={ styles.appInfo }>
                <div className={ styles.title }>{option.title}</div>
                <div className={ styles.value }>{option.value}</div>
            </div>
        ))}
    </div>
    );
}



const mapStateToProps = state => ( 
    {  
        simmVersion: state.app.simmVersion
    }
)

const mapDispatchToProps = {
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HelpInfo));
